module.exports = __webpack_public_path__ + "img/shrunken_head_in_night_bus.0ca9b5aa.jpg";